import React from 'react';

const Notification = ({ setCollapse, notificationData, viewMoreData }) => {
  return (
    <div
      className="absolute right-[0px] top-[103px] z-50 flex w-[316px] flex-col justify-between bg-white shadow-md"
      style={{ height: 'calc(100vh - 104px)' }}
    >
      <div className="flex h-[54px] w-full items-center justify-between bg-light-blue p-4 text-lg font-semibold text-medium-grey">
        <div>
          <img
            src={'/assets/Icon%20feather-menu.svg'}
            alt="Icon"
            className="h-[13.6px] w-[20.6px]"
          />
        </div>
        <p className="text-xl font-thin leading-normal">Notification</p>
        <div
          className={'cursor-pointer hover:brightness-0'}
          onClick={() => {
            setCollapse(false);
          }}
        >
          <img
            src={'/assets/Icon%20ionic-ios-close.svg'}
            alt="Icon"
            className="h-[13.5px] w-[13.5px]"
          />
        </div>
      </div>
      <div className="w-full overflow-y-auto" id="noticfication-scrollbar">
        {notificationData?.items?.map((data, index) => (
          <div
            key={index}
            className="flex cursor-pointer items-center justify-center gap-4 px-5 py-3 hover:bg-gray-200"
          >
            <img
              src={'/assets/Icon%20ionic-md-alert.svg'}
              alt="Icon"
              className="h-[24.6px] w-[24.6px]"
            />
            <div className="text-[12px] font-thin leading-normal text-medium-grey">
              {data.description}
            </div>
            <div>
              {data?.seen ? (
                ' '
              ) : (
                <div className="h-[10px] w-[10px] rounded-full bg-medium-blue-100"></div>
              )}
            </div>
          </div>
        ))}
        <div
          className="item-center flex h-[30px] w-full cursor-pointer justify-center bg-blue-50 text-blue-900"
          onClick={() => {
            viewMoreData();
          }}
        >
          View More
        </div>
      </div>
    </div>
  );
};
export default Notification;
